import type { PropsWithChildren } from "react";

export function PriceTag(props: { color?: string; backgroundColor?: string } & PropsWithChildren) {
  const backgroundColor = props.backgroundColor ?? "#4285f4";
  return (
    <div
      style={{
        backgroundColor,
        borderRadius: 8,
        color: props.color ?? "#ffffff",
        fontSize: 14,
        padding: 8,
        position: "relative",
        transform: "translateY(-8px)",
      }}
    >
      {props.children}
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "100%",
          transform: "translate(-50%, 0)",
          width: 0,
          height: 0,
          borderLeft: "8px solid transparent",
          borderRight: "8px solid transparent",
          borderTop: `8px solid ${backgroundColor}`,
        }}
      />
    </div>
  );
}
